import React, { useState, useRef } from "react";

const EmailStep = ({ onSubmit }) => {
  const [email, setEmail] = useState("");
  const ref = useRef(null);
  const defaultEmail = localStorage.getItem('emailId'); // Renamed to defaultEmail
  const loggedInUser = localStorage.getItem('token');


  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(email);
    // console.log(ref.current.value);
  };

  return (
    <div>
      {loggedInUser && (
        <form onSubmit={handleSubmit} className="mx-0">
          <label htmlFor="emailid" className="form-label">
            Email Address
          </label>
          <input
            className="form-control"
            ref={ref} 
            defaultValue={defaultEmail}
            type="email"
            id="emailid"
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Your Email"
            required
            aria-label="Email Address" // Accessibility attribute
          />
          <button type="submit" className="btn btn__primary mt-2"> {/* Updated button class */}
            Submit
          </button>
        </form>
      )}
      {!loggedInUser && (
        <form onSubmit={handleSubmit} className="mx-0">
          <label htmlFor="emailid" className="form-label">
            Email Address
          </label>
          <input
            className="form-control"
            ref={ref} 
            defaultValue={email}
            type="email"
            id="emailid"
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Your Email"
            required
            aria-label="Email Address" // Accessibility attribute
          />
          <button type="submit" className="btn btn__primary mt-2"> {/* Updated button class */}
            Submit
          </button>
        </form>
      )}
    </div>
  );
};

export default EmailStep;